import { Button, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaPredicate } from 'react-media-hook';
import { Marker } from 'react-image-marker';
import { Validate, ValidationGroup } from 'mui-validate';
import DialogBase from '../../../Shared/DialogBase';
import { useApi } from '../../../../ApiOld/Api/useApi';
import { EmployeesVovClient } from '../../../../ApiOld/Api/ApiServerVov';
import { CreateEmployeeFileRequest } from '../../../../ApiOld/ApiServerVov';

export interface EmployeeCreateFolderDialogProps {
    open: boolean;
    employeeId: number;
    parentId: number | undefined;
    onClose: (value: boolean) => void;
}


export default function EmployeeCreateFolderDialog(props: EmployeeCreateFolderDialogProps) {
    const { onClose, open, employeeId, parentId } = props;
    const { t, i18n } = useTranslation();
    const biggerThan600 = useMediaPredicate("(min-width: 600px)");
    const [loading, setLoading] = useState<boolean>(false);
    const [name, setName] = useState('');

    const { authorizedApi } = useApi(EmployeesVovClient);

    useEffect(() => {
        setLoading(false);
    }, []);

    useEffect(() => {
        if (open) setName('');
    }, [open]);

    async function saveFolder(): Promise<boolean> {
        try {
            if (name.length > 0) {
                setLoading(true);
                authorizedApi.createEmployeeFile(new CreateEmployeeFileRequest({ employeeId: employeeId, parentDocumentId: parentId, name: name })).then((res) => {
                    if (res.ok) {
                        onClose(true);
                    }
                    setLoading(false);
                });
            }
            return true;
        }
        catch {
            setLoading(false);
            return false;
        }
    }

    async function onSaveClicked() {
        await saveFolder();
    }

    interface CustomMarker extends Marker {
        type: "success" | "error" | "warning";
        content: string;
        deviceId?: string | number;
    }


    return (
        <DialogBase minWidth={biggerThan600 ? '60%' : '90%'} showFullScreenButton marginTop='40px' maxWidth='lg' showCloseButton title={t('files.createFolder')} open={open} onClose={() => { onClose(false) }}>
            {loading && <div style={{ margin: 'auto', minHeight: '400px', minWidth: '350px', display: 'block' }}>
                {/* <div>
                    <Save sx={{ width: '30px', height: '30px', marginTop: '80px', marginBottom: '10px' }} />
                </div> */}
                <div style={{ fontSize: '20px', marginBottom: '10px', marginTop: '80px' }}>
                    {t('savingDots')}
                </div>
                <div>
                    <CircularProgress sx={{ opacity: '1', width: '16px', height: '16px', margin: 'auto', marginLeft: '25px' }} />
                </div>
            </div>
            }
            {!loading && <div style={{ display: 'flex', flexDirection: 'column'/* , backgroundColor: '#F5F5F5' */ }} >
                <ValidationGroup>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', margin: "10px" }}>
                            <Validate name='name-todo-validate' initialValidation={'noisy'} required={[true, t('FieldRequired')]}>
                                <TextField
                                    error={name === ''}
                                    size='small'
                                    fullWidth sx={{ width: '95%', minWidth: '95%', margin: "10px", borderRadius: '30px', marginTop: "6px", marginBottom: '6px', backgroundColor: '#FFFFFF' }}
                                    onChange={e => setName(e.target.value)}
                                    label={(t('Name'))} value={name} />
                            </Validate>
                        </div>
                        <div style={{ height: '1px', marginTop: '4px', backgroundColor: '#F5F5F5' }}></div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ margin: 'auto' }}>
                                <Button onClick={() => { onSaveClicked() }} sx={{ backgroundColor: '#FFC600', color: 'black', justifyContent: "flex-start", margin: "16px", marginBottom: "32px" }}>{t('files.createFolder')}</Button>
                            </div>

                        </div>
                    </div>
                </ValidationGroup>
            </div >}
        </DialogBase>
    );
};
